import React from "react";
import { TableTabs } from "./table-tabs/TableTabs";

export const OrderModule = () => {
	return <TableTabs />;
};
